"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FusionContainer = void 0;
var React = __importStar(require("react"));
var FusionProvider_1 = require("./FusionProvider");
var mappers_1 = require("./mappers");
exports.FusionContainer = function (_a) {
    var children = _a.children, modalClassNames = _a.modalClassNames, dialogClassNames = _a.dialogClassNames;
    React.useEffect(function () {
        var resizeOps = function () {
            document.documentElement.style.setProperty("--fusion-vh", window.innerHeight * 0.01 + "px");
        };
        resizeOps();
        window.addEventListener("resize", resizeOps);
        return function () {
            window.removeEventListener("resize", resizeOps);
        };
    });
    return (React.createElement(FusionProvider_1.FusionProvider, { modalClassNames: modalClassNames, dialogClassNames: dialogClassNames },
        children,
        React.createElement(mappers_1.ModalMapper, null),
        React.createElement(mappers_1.DialogMapper, null)));
};
